// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".field-wrapper[data-v-791389db]{min-width:0}.hidden[data-v-791389db]{pointer-events:none;position:absolute;visibility:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
